import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { JobDetailPage } from '@/features/jobs/job-detail-page';
import { isJobTab, type JobTab } from '@/features/jobs/job-tabs';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/** L'onglet actif vit dans l'URL (`?tab=runs`) : une capture ou un lien pointe sur un onglet précis. */
export const Route = createFileRoute('/$tenant/projects/$projectId/jobs/$jobId/')({
  validateSearch: (search: Record<string, unknown>): { tab: JobTab } => ({
    tab: isJobTab(search['tab']) ? search['tab'] : 'summary',
  }),
  component: JobDetailRoute,
});

function JobDetailRoute() {
  const { tenant, projectId, jobId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();

  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="jobs"
      crumbs={[
        { label: t('nav.items.jobs') },
        { label: <EntityName tenantId={tenant} kind="job" id={jobId} scope={{ projectId }} /> },
      ]}
    >
      <JobDetailPage
        tenantId={tenant}
        projectId={projectId}
        jobId={jobId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
